var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container_message"},[_c('MessageTypeLeft',{ref:"messageTypeLeftRef"}),_c('MessageListRight',{ref:"messageListRightRef"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }